import { compose } from 'redux';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { fillConfigFieldsWithKeys } from 'utils/loanManagement';

import { ManualContactField } from '../../AppraisalOrderContactsCard.constants';
import { AppraisalOrderContactsCardTestIds } from '../../AppraisalOrderContactsCard.testIds';

import {
  MANUAL_CONTACT_EMAIL_MAX_LENGTH,
  MANUAL_CONTACT_NAME_MAX_LENGTH,
  MANUAL_CONTACT_PHONE_MAX_LENGTH,
} from './ManualContactForm.constants';

const getNameField = ({ fieldId, label, testIdKey }) => ({
  fieldId,
  type: FieldType.INPUT,
  nameInModel: fieldId,
  inputProps: {
    label,
    placeholder: label,
    required: true,
    variant: 'outlined',
    type: FieldInputType.TEXT,
    maxLength: MANUAL_CONTACT_NAME_MAX_LENGTH,
    dataTestId: AppraisalOrderContactsCardTestIds.getManualContactInputId(testIdKey),
  },
});

const getPhoneField = ({ fieldId, label, testIdKey }) => ({
  fieldId,
  type: FieldType.TEL,
  nameInModel: fieldId,
  inputProps: {
    label,
    placeholder: label,
    required: false,
    variant: 'outlined',
    type: FieldInputType.TEL,
    maxLength: MANUAL_CONTACT_PHONE_MAX_LENGTH,
    dataTestId: AppraisalOrderContactsCardTestIds.getManualContactInputId(testIdKey),
  },
});

const manualContactFields = {
  [ManualContactField.FIRST_NAME]: getNameField({
    fieldId: ManualContactField.FIRST_NAME,
    label: 'First Name',
    testIdKey: 'first-name',
  }),
  [ManualContactField.LAST_NAME]: getNameField({
    fieldId: ManualContactField.LAST_NAME,
    label: 'Last Name',
    testIdKey: 'last-name',
  }),
  [ManualContactField.EMAIL]: {
    fieldId: ManualContactField.EMAIL,
    type: FieldType.INPUT,
    nameInModel: ManualContactField.EMAIL,
    inputProps: {
      label: 'Email',
      placeholder: 'Email',
      required: false,
      variant: 'outlined',
      type: FieldInputType.EMAIL,
      maxLength: MANUAL_CONTACT_EMAIL_MAX_LENGTH,
      dataTestId: AppraisalOrderContactsCardTestIds.getManualContactInputId('email'),
    },
  },
  [ManualContactField.CELL_PHONE]: getPhoneField({
    fieldId: ManualContactField.CELL_PHONE,
    label: 'Cell Phone',
    testIdKey: 'cell-phone',
  }),
  [ManualContactField.HOME_PHONE]: getPhoneField({
    fieldId: ManualContactField.HOME_PHONE,
    label: 'Home Phone',
    testIdKey: 'home-phone',
  }),
  [ManualContactField.WORK_PHONE]: getPhoneField({
    fieldId: ManualContactField.WORK_PHONE,
    label: 'Business Phone',
    testIdKey: 'business-phone',
  }),
  [ManualContactField.PHONE]: getPhoneField({
    fieldId: ManualContactField.PHONE,
    label: 'Phone',
    testIdKey: 'phone',
  }),
};

export const getManualContactFormConfig = compose(fillConfigFieldsWithKeys, fields => ({
  groups: [
    {
      type: FieldType.GROUP,
      fields: fields.map(field => manualContactFields[field]),
      key: 'manual-order-contact',
    },
  ],
}));
